/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useState } from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import { SketchPicker } from 'react-color';
import * as S from '../../styles';

export interface IColorPickerProps {
    id: string;
    fontScale?: number;

    label?: string;
    labelColor?: string;
    errorText?: string;
    value?: string;
    required?: boolean;
    onCompChange?(id: string, payload: any): void;
    hasError?: boolean;
}

export const ColorPicker = ({
    id,
    fontScale,

    label,
    labelColor,
    errorText,
    value,
    required,
    onCompChange,
    hasError,
}: IColorPickerProps) => {
    const [textValue, setTextValue] = useState(value ?? '');
    const onChange = (id: string, e: any) => {
        setTextValue(e?.hex);
        onCompChange && onCompChange(id, e?.hex);
    };
    const _renderLabelIf = () => {
        if (label) {
            return (
                <S.FormLabel fontScale={fontScale} color={labelColor}>
                    {label}
                    {required && <sup style={{ color: 'red' }}>*</sup>}
                </S.FormLabel>
            );
        }
        return null;
    };

    const _renderErrorTextIf = () => {
        if (hasError && errorText) {
            return (
                <S.FeedbackOtherLabel type="tooltip" fontScale={fontScale}>
                    {errorText}
                </S.FeedbackOtherLabel>
            );
        }
        return null;
    };

    return (
        <>
            <Form.Group id={id} className=" formgroup">
                {_renderLabelIf()}
                <InputGroup>
                    <SketchPicker
                        style={{
                            borderWidth: '0px',
                            borderColor: 'transparent',
                        }}
                        color={textValue}
                        onChangeComplete={onChange?.bind(null, id)}
                    />
                    <InputGroup>{_renderErrorTextIf()}</InputGroup>
                </InputGroup>
            </Form.Group>
        </>
    );
};

ColorPicker.defaultProps = {
    required: false,
    hasError: false,
};
